import { useEffect, useContext } from 'react';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import GlobalContext from '../../../contexts';
import translating from '../translate.json';
import fields from '../fields';
import { useNavigate } from 'react-router-dom';

const CreateBloodparam = () => {
  const navigate = useNavigate();
  const { postData, res } = usePostData();
  const { categoriesList, setLink } = useContext(GlobalContext);

  useEffect(() => {
    if (res?.id) {
      setLink(null);
      navigate(`/labs/blood?added=true`);
    }
  }, [res]);

  const onSubmit = (data) => {
    console.log(data);
    postData('blood-param', data);
  };
  return (
    <div className="create-product">
      <SectionHeader title={translating.createBloodParam}></SectionHeader>
      <FormGroup
        fields={fields(categoriesList)}
        onSubmit={onSubmit}
        categories={categoriesList}
      ></FormGroup>
    </div>
  );
};

export default CreateBloodparam;
